import React, { useState, useEffect, useCallback } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS
import "ag-grid-community/styles/ag-theme-alpine.css"; // Alpine theme CSS
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PropTypes from "prop-types";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import useBusinessEntryApiCall from "customApiHooks/useBusinessEntryApiCall";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { Tooltip } from "@mui/material";
import CurrencyInput from "react-currency-input-field";
import Cookie from "js-cookie";
import dayjs from "dayjs";
import {
  Switch,
  Grid,
  MenuItem,
  Checkbox,
  Card,
  TableContainer,
  Paper,
  TextField,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  CircularProgress,
  Typography,
  Autocomplete,
  InputAdornment,
  Popover,
  Box,
  FormControlLabel,
  Tab,
  Tabs,
  TableCell,
  TableRow,
  TableHead,
  TableBody,
  Table,
  ListItem,
  ListItemText,
  List,
  CardContent,
} from "@mui/material";
import MDBox from "components/MDBox";
import {
  ViewButton,
  DeleteButton,
  StyledTypography,
  StyledTypographyA,
  StyledTypographyAA,
  StyledButton,
  StyledButtonC,
  StyledAlert,
  StyledSnackbar,
  StyledIconButton,
  StyledButtonAbort,
  StyledButtonAnchor,
  inputStyle,
  StyledAgGridContainer,
  CustomSwitch,
  StyledTableContainer,
  CustomTableCell,
} from "components/StyledComponents/styledComponents.js";
import { format } from "date-fns";
import { subDialogContentStyle, dialogContentTextStyle } from "components/Styles/approvalStyles";
import { tableShadow, globalStyles, CustomPaper } from "components/Styles/globalStyles";
import useBusinessMonthYear from "components/GlobalHooks/useMonthlyBusiness";
import { entryStyles } from "components/Styles/loanEntryStyles";
import ResponsiveTabs from "components/StyledComponents/styledComponents";
import FilterSection from "components/Forms/BusinessEntry/EntryComponents";
import { useMaterialUIController } from "context";
import URLs from "constants/urls";
export default function InsuranceEntry() {
  const [controller] = useMaterialUIController();
  const { user } = controller;
  const [activeTab, setActiveTab] = useState(0);
  const [renewalTab, setRenewalTab] = useState(0);
  const [selectedGroup, setSelectedGroup] = useState("");
  const [selectedManager, setSelectedManager] = useState("");
  const [selectedDSA, setSelectedDSA] = useState("");
  const [selectedSubDSA, setSelectedSubDSA] = useState(-1);
  const [selectedLoanType, setSelectedLoanType] = useState("");
  const [selectedAppliedTo, setSelectedAppliedTo] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [providerPayout, setProviderPayout] = useState("");
  const [dsaPayout, setDSAPayout] = useState(0);
  const [selectedDsaSalesManager, setSelectedDsaSalesManager] = useState("");
  const [applicationNumber, setApplicationNumber] = useState("");
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [LoanAmount, setLoanAmount] = useState("");
  const [remarks, setRemarks] = useState("");
  const [entryId, setEntryId] = useState("");
  const [serviceEntryId, SetServiceEntryId] = useState("");
  const [subDsaPayout, setSubDsaPayout] = useState(0);
  const [subDsaId, setSubDsaId] = useState(0);
  const [serviceTypeCode, setServiceTypeCode] = useState("IN");
  const [grossPayoutAmount, setGrossPayoutAmount] = useState(0);
  const [dsaPayoutAmount, setDsaPayoutAmount] = useState(0);
  const [dsaStatus, setDsaStatus] = useState(false);
  const [businessMonthId, setBusinessMonthId] = useState(0);
  const [businessStatus, setBusinessStatus] = useState("N");
  const [filteredSubDsaManagers, setFilteredSubDsaManagers] = useState([]);
  const [dsaTdsPercent, setDsaTdsPercent] = useState("");
  const [subDsaTdsPercent, setSubDsaTdsPercent] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [openDailogAbortBox, setOpenDailogAbortBox] = useState(false);
  const [unAbortbox, setUnAbortBox] = useState(false);
  const [businessStatusFilter, setBusinessStatusFilter] = useState(0);
  const [disbursedAmount, setDisbursedAmount] = useState("");
  const [loginDate, setLoginDate] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const jwt_token = Cookie.get("jwt_token");
  const [productType, setProductType] = useState("");
  const [disbursements, setDisbursements] = useState([]);
  const [selectedEntryData, setSelectedEntryData] = useState({});
  const [entryCondition, setEntryCondition] = useState({});
  const [connectorFormData, setConnectorFormData] = useState({
    connectorId: "",
    connectorName: "",
    panNumber: "",
    hasGST: false,
    gstNumber: "",
  });
  const [connectorData, setConnectoreData] = useState([]);
  const [localConnectorData, setLocalConnectorData] = useState(connectorData || []);
  const [actualDsaPayout, setActualDsaPayout] = useState("");
  const [disbursedState, setDisbursedState] = useState(false);
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth(); // 0-based index

  const startOfMonth = new Date(year, month, 2).toISOString().split("T")[0];
  const endOfMonth = new Date(year, month + 1, 1).toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(startOfMonth);
  const [toDate, setToDate] = useState(endOfMonth);
  const [payouts, setPayouts] = useState({
    providerPayoutAmount: 0,
    tdsOnProviderPayout: 0,
    finalProviderPayoutAmount: 0,
    dsaPayoutAmountD: 0,
    tdsOnDsaPayout: 0,
    finalDsaPayoutAmount: 0,
    connectorPayout: 0,
    tdsOnConnectorPayout: 0,
    finalConnectorPayoutAmount: 0,
  });
  const [startDate, setStartDate] = useState("");
  const [duration, setDuration] = useState("");
  const [frequency, setFrequency] = useState("");
  const [dueDates, setDueDates] = useState([]);
  const [endDate, setEndDate] = useState("");
  const [nextDue, setNextDue] = useState("");
  const frequencyToMonths = {
    Yearly: 12,
    "Half-Yearly": 6,
    Quarterly: 3,
    Monthly: 1,
  };
  const handleConnectorChange = (e) => {
    const { name, value } = e.target;
    setConnectorFormData({ ...connectorFormData, [name]: value });
  };
  const handleOpenPopover = (event) => setAnchorEl(event.currentTarget);
  const handleClosePopover = () => setAnchorEl(null);
  const handleConnectorSave = async () => {
    if (
      !connectorFormData.connectorId ||
      !connectorFormData.connectorName ||
      !connectorFormData.panNumber
    ) {
      setAlert("Please fill in Connector ID and Connector Name and PanNumber", "error");
      return;
    }

    if (connectorFormData.hasGST && !connectorFormData.gstNumber) {
      setAlert("Please enter the GST Number.", "error");
      return;
    }
    const newConnector = { ...connectorFormData };
    await postDsaMasterApiCall(newConnector, setConnectorFormData);
    handleClosePopover();
  };
  const openC = Boolean(anchorEl);
  const id = openC ? "connector-popover" : undefined;
  const { monthIdData, loadingBId, fetchData } = useBusinessMonthYear();
  const [businessMonthID, setBusinessMonthID] = useState();
  const MInput = inputStyle();
  const handleReset = () => {
    setSelectedGroup("");
    setSelectedManager("");
    setSelectedDSA("");
    setSelectedSubDSA(-1); // Empty string to match type
    setSelectedLoanType("");
    setSelectedAppliedTo("");
    setCustomerName("");
    setProviderPayout("");
    setDSAPayout("");
    setSelectedDsaSalesManager("");
    setApplicationNumber("");
    setLoanAmount("");
    setRemarks("");
    setSubDsaPayout("");
    setEditStatus(false);
    setDate(new Date().toISOString().slice(0, 10)); // Reset to current date if needed
    setLoginDate(new Date().toISOString().slice(0, 10));
    setEntryId("");
    setGrossPayoutAmount(0);
    setDsaPayoutAmount(0);
    setDsaStatus(false);
    setBusinessStatus("N");
    setEntryCondition("N");
    setDsaTdsPercent("");
    setSubDsaTdsPercent("");
    setDisbursedAmount("");
    setLoginDate(new Date().toISOString().slice(0, 10));
    setActualDsaPayout("");
    setDisbursedState(false);
    setServiceTypeCode("");
    setStartDate("");
    setDuration("");
    setFrequency("");
    setDueDates([]);
    setEndDate("");
    setNextDue("");
    setPayouts({
      providerPayoutAmount: 0,
      tdsOnProviderPayout: 0,
      finalProviderPayoutAmount: 0,
      dsaPayoutAmountD: 0,
      tdsOnDsaPayout: 0,
      finalDsaPayoutAmount: 0,
      connectorPayout: 0,
      tdsOnConnectorPayout: 0,
      finalConnectorPayoutAmount: 0,
    });
  };
  const inputStatus = false;
  const switchStatus = false;
  const {
    businessMasterData,
    providerData,
    deleteInsuranceEntry,
    dsaData,
    entryData,
    subDsaData,
    managersData,
    dsaManagersData,
    message,
    alertType,
    open,
    editStatus,
    fetchInsuranceConfigs,
    insuranceConfigs,
    loading,
    finalFinanceData,
    setLoading,
    setEditStatus,
    companyConfig,
    fetchEntriesFeildsData,
    fetchEntriesByTypeCode,
    fetchInsuranceAgents,
    insuranceAgents,
    postDsaMasterApiCall,
    fetchFilteredFinanceDetails,
    fetchBusinessEntriesApiCall,
    fetchFinanceDetails,
    postEntry,
    fetchInsuranceEntriesApiCall,
    postInsuranceEntry,
    putEntry,
    deleteEntry,
    setAlert,
    handleClose,
    putInsuranceEntry,
  } = useBusinessEntryApiCall("IN", handleReset);
  const generateDueDates = (start, freq, years) => {
    const interval = frequencyToMonths[freq];
    let dates = [];
    let current = dayjs(start);
    const end = dayjs(start).add(Number(years), "year");
    setEndDate(end.format("MM-DD-YYYY"));

    while (current.isBefore(end) || current.isSame(end)) {
      dates.push(current);
      current = current.add(interval, "month");
    }

    const today = dayjs();
    const upcoming = dates.find((date) => date.isAfter(today));
    setNextDue(upcoming ? upcoming.format("MM-DD-YYYY") : "Policy Ended");
    dates.pop(dates.length - 1); // Remove the last date
    return dates.map((d) => d.format("MM-DD-YYYY"));
  };
  const handleGenerate = () => {
    if (startDate && frequency && duration) {
      if (insuranceConfigs.length === 0 && !selectedAppliedTo) {
        setAlert("Please select insurance type, provider first to generate due dates", "error");
        return;
      }
      const result = generateDueDates(startDate, frequency, duration);
      const dueDateObjects = result.map((date, index) => {
        // Find config matching termNo == index + 1
        const config = insuranceConfigs.find((cfg) => cfg.termNo === index + 1);
        // If not found (i.e., more schedules than terms), use the last config
        const lastConfig = insuranceConfigs[insuranceConfigs.length - 1];
        return {
          scheduleDate: date,
          payoutPercent: parseFloat(config ? config.payout : lastConfig.payout) || 0,
          gst: parseFloat(config ? config.gstpercent : lastConfig.gstpercent) || 0,
          premiumAmount: parseFloat(LoanAmount) || 0,
          remarks: "",
          paidStatus: "N",
          payoutStatus: "N",
        };
      });
      setDueDates(dueDateObjects);
    } else {
      setAlert("Please fill startDate, frequency, duration'", "error");
    }
  };
  //   const interval = frequencyToMonths[freq];
  //   if (!interval) return [];

  //   let dates = [];
  //   let current = dayjs(start);
  //   const end = dayjs(start).add(Number(years), "year");
  //   setEndDate(end.format("MM-DD-YYYY"));

  //   while (current.isBefore(end) || current.isSame(end)) {
  //     dates.push(current);
  //     current = current.add(interval, "month");
  //   }

  //   // Remove the last date if it exceeds the end
  //   if (dates.length > 0 && dates[dates.length - 1].isAfter(end)) {
  //     dates.pop();
  //   }

  //   const today = dayjs();
  //   const upcoming = dates.find((date) => date.isAfter(today));
  //   setNextDue(upcoming ? upcoming.format("MM-DD-YYYY") : "Policy Ended");

  //   return dates.map((d) => d.format("MM-DD-YYYY"));
  // };
  const calculateFrequencyAndDuration = (schedules) => {
    if (!schedules || schedules.length === 0) return { frequency: "", duration: "" };

    const firstDate = new Date(schedules[0].scheduleDate);
    const lastDate = new Date(schedules[schedules.length - 1].scheduleDate);

    const duration = Math.floor((lastDate - firstDate) / (1000 * 60 * 60 * 24 * 365)) + 1;

    let frequency = "Yearly"; // Default fallback

    if (schedules.length > 1) {
      const diffInMonths = dayjs(schedules[1].scheduleDate).diff(
        dayjs(schedules[0].scheduleDate),
        "month"
      );
      if (diffInMonths === 1) frequency = "Monthly";
      else if (diffInMonths === 3) frequency = "Quarterly";
      else if (diffInMonths === 6) frequency = "Half-Yearly";
      else if (diffInMonths === 12) frequency = "Yearly";
    }

    return { frequency, duration: duration.toString() };
  };
  const filteredDsaMngrFunction = useCallback(() => {
    const defaultManager = {
      firstName: "No",
      lastName: "Manager",
      employeeId: 0,
    };
    if (selectedSubDSA) {
      return [
        defaultManager,
        ...dsaManagersData.filter((item) => item.companyId === selectedSubDSA),
      ];
    }
    return [defaultManager];
  }, [selectedSubDSA, dsaManagersData]);
  useEffect(() => {
    if (selectedLoanType) {
      fetchFinanceDetails(selectedLoanType);
      fetchInsuranceConfigs(selectedLoanType);
    }
  }, [selectedLoanType]);
  useEffect(() => {
    const filteredData = filteredDsaMngrFunction();
    setFilteredSubDsaManagers(filteredData); // Update filtered managers state
  }, [filteredDsaMngrFunction, selectedSubDSA]);
  useEffect(() => {
    if (!editStatus && finalFinanceData.length > 0) {
      const selectedFinance = finalFinanceData.find(
        (eachEntry) => eachEntry.finananceId == selectedAppliedTo
      );

      if (selectedFinance) {
        setProviderPayout(selectedFinance.grossPayOut);
        if (selectedSubDSA === -1) {
          setSubDsaPayout(0);
          setDSAPayout(0);
          setSubDsaPayout(selectedFinance.dsaPayOut);
        } else {
          setDSAPayout(0);
          setSubDsaPayout(selectedFinance.dsaPayOut);
        }
      }
    }
  }, [selectedAppliedTo, finalFinanceData, editStatus]);
  useEffect(() => {
    if (selectedSubDSA === -1) {
      setSubDsaPayout(0);
      setDSAPayout(0);
    }
  }, []);
  useEffect(() => {
    if (!dsaStatus) {
      setSelectedSubDSA("");
      setSelectedDsaSalesManager(0);
      setSubDsaPayout("");
    }
  }, [dsaStatus]);
  useEffect(() => {
    if (companyConfig) {
      setSubDsaTdsPercent(companyConfig.companyTDSPercent);
      setDsaTdsPercent(companyConfig.companyTDSPercent);
    }
  }, [companyConfig]);
  useEffect(() => {
    if (LoanAmount && providerPayout) {
      calculatePayouts();
    }
  }, [LoanAmount, providerPayout, subDsaPayout]);
  useEffect(() => {
    if (activeTab === 0 && monthIdData) {
      setBusinessMonthID(monthIdData[0]?.businessMonthID || "");
      fetchInsuranceEntriesApiCall(fromDate, toDate);
    }
  }, [activeTab, monthIdData]);
  const handleGetData = () => {
    fetchInsuranceEntriesApiCall(fromDate, toDate);
  };
  const handleFilter = useCallback(() => {
    fetchFilteredFinanceDetails(serviceTypeCode, businessStatusFilter, businessMonthID);
  }, [businessStatusFilter, businessMonthID]);
  const frequencyOptions = ["Yearly", "Half-Yearly", "Quarterly", "Monthly"];

  const calculatePayouts = () => {
    const roundToTwoDecimals = (value) => Math.round(value * 100) / 100;
    const providerPayoutAmount = roundToTwoDecimals((LoanAmount * providerPayout) / 100);
    const tdsOnProviderPayout = 0;
    const finalProviderPayoutAmount = 0;
    const dsaPayoutAmountD = 0;
    const tdsOnDsaPayout = 0;
    const finalDsaPayoutAmount = 0;
    const connectorPayout = roundToTwoDecimals((LoanAmount * subDsaPayout) / 100);
    const tdsOnConnectorPayout = 0;
    const finalConnectorPayoutAmount = connectorPayout;
    const data = {
      providerPayoutAmount,
      tdsOnProviderPayout,
      finalProviderPayoutAmount,
      dsaPayoutAmountD,
      tdsOnDsaPayout,
      finalDsaPayoutAmount,
      connectorPayout,
      tdsOnConnectorPayout,
      finalConnectorPayoutAmount,
    };
    setPayouts({
      providerPayoutAmount,
      tdsOnProviderPayout,
      finalProviderPayoutAmount,
      dsaPayoutAmountD,
      tdsOnDsaPayout,
      finalDsaPayoutAmount,
      connectorPayout,
      tdsOnConnectorPayout,
      finalConnectorPayoutAmount,
    });
    return data;
  };
  const postLoanEntryApiCall = () => {
    const payouts = calculatePayouts();
    const insuranceRenewalData = dueDates.map((item) => {
      const d = new Date(item.scheduleDate);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const day = d.getDate().toString().padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;

      return {
        entryId: 0,
        scheduleDate: formattedDate,
        premiumAmount: parseFloat(parseFloat(LoanAmount).toFixed(2)),
        payoutPercent: parseFloat(parseFloat(item.payoutPercent).toFixed(2)) || 0,
        gst: parseFloat(parseFloat(item.gst).toFixed(2)) || 0,
        paidStatus: "N",
        payoutStatus: "N",
        remarks: item.remarks,
      };
    });

    const data = {
      businessEntries: {
        entryId: 0,
        dsaId: parseInt(selectedDSA),
        subDsaId: parseInt(selectedSubDSA),
        applicationNumber: applicationNumber,
        businessType: productType,
        date: date,
        businessMonthId: parseInt(businessMonthId),
        employeeId: parseInt(selectedManager),
        dsaEmployeeId: user.employeeId,
        businessId: parseInt(selectedLoanType),
        customerName: customerName,
        finananceId: parseInt(selectedAppliedTo),
        appliedAmount: parseFloat(parseFloat(LoanAmount).toFixed(2)),
        businessStatus: disbursedState ? 4 : 0,
        loginDate: loginDate,
        businessEntriesMIS: {
          grossPayoutPercent: parseFloat(parseFloat(providerPayout).toFixed(2)),
          grossPayoutAmount: parseFloat(parseFloat(payouts.providerPayoutAmount).toFixed(2)),
          remarks: remarks,
          dsamargin: parseFloat(parseFloat(dsaPayout).toFixed(2)),
          dsapayoutAmount: parseFloat(parseFloat(payouts.dsaPayoutAmountD).toFixed(2)),
          misstatus: disbursedState ? "C" : "N",
          subDSAPaymentAmount: parseFloat(parseFloat(payouts.connectorPayout).toFixed(2)),
          subDSAPayoutPercent: parseFloat(parseFloat(subDsaPayout || 0).toFixed(2)),
          dsapayoutPercent: parseFloat(parseFloat(actualDsaPayout || 0).toFixed(2)),
        },
      },
      insuranceDtos: insuranceRenewalData,
    };
    postInsuranceEntry(data, setActiveTab);
  };
  const putLoanEntryApiCall = (entryStatus) => {
    const formattedDate = format(new Date(date), "yyyy-MM-dd");
    const formattedLoginDate = format(new Date(loginDate), "yyyy-MM-dd");
    const formattedDueDates = dueDates.map((item) => ({
      ...item,
      entryId: entryId,
      scheduleDate: format(new Date(item.scheduleDate), "yyyy-MM-dd"),
    }));
    const payouts = calculatePayouts();
    const data = {
      businessEntries: {
        ...selectedEntryData.businessEntry,
        entryId: parseInt(entryId),
        dsaId: parseInt(selectedDSA),
        subDsaId: parseInt(selectedSubDSA),
        applicationNumber: applicationNumber,
        businessType: productType,
        date: formattedDate,
        loginDate: formattedLoginDate,
        employeeId: parseInt(selectedManager),
        businessId: parseInt(selectedLoanType),
        customerName: customerName,
        finananceId: parseInt(selectedAppliedTo),
        appliedAmount: parseFloat(parseFloat(LoanAmount).toFixed(2)),
        loginDate: loginDate,
        businessEntriesMIS: {
          ...selectedEntryData.misData,
          grossPayoutPercent: parseFloat(parseFloat(providerPayout).toFixed(2)),
          grossPayoutAmount: parseFloat(parseFloat(payouts.providerPayoutAmount).toFixed(2)),
          subDSAPaymentAmount: parseFloat(parseFloat(payouts.connectorPayout).toFixed(2)),
          dsapayoutPercent: parseFloat(parseFloat(actualDsaPayout || 0).toFixed(2)),
          subDSAPayoutPercent: parseFloat(parseFloat(subDsaPayout || 0).toFixed(2)),
          dsamargin: parseFloat(parseFloat(dsaPayout).toFixed(2)),
          remarks: remarks,
          misstatus: disbursedState ? "C" : selectedEntryData.misData.misstatus,
          dsapayoutAmount: parseFloat(parseFloat(payouts.dsaPayoutAmountD).toFixed(2)),
          misamount: parseFloat(parseFloat(LoanAmount).toFixed(2)),
        },
      },
      insuranceDtos: formattedDueDates,
    };
    if (dueDates.length > 0) {
      putInsuranceEntry(entryId, data, setActiveTab);
    } else {
      setAlert("Please generate due dates", "error");
    }
  };

  const deleteLoanEntryApiCall = (lEntryId) => {
    deleteInsuranceEntry(lEntryId);
  };
  const handleEditLoanRow = (rowData) => {
    const entry = rowData.businessEntry || {};
    const mis = rowData.misData || {};
    const insuranceDtos = rowData.insuranceDtos || [];
    setDueDates(insuranceDtos);
    setEndDate(
      insuranceDtos.length > 0 ? insuranceDtos[insuranceDtos.length - 1].scheduleDate || "" : ""
    );

    setNextDue(insuranceDtos.length > 0 ? insuranceDtos[0].scheduleDate || "" : "");
    const { frequency, duration } = calculateFrequencyAndDuration(rowData.insuranceDtos);
    setFrequency(frequency);
    setDuration(duration);
    setActiveTab(1);
    setSelectedEntryData(rowData);
    setEditStatus(true);
    setApplicationNumber(entry.applicationNumber || "");
    setLoanAmount(entry.appliedAmount || 0);
    setSelectedLoanType(entry.businessId || "");
    setCustomerName(entry.customerName || "");
    setDate(formatTimestampToDate(entry.date));
    setLoginDate(formatTimestampToDate(entry.loginDate));
    setSelectedDSA(entry.dsaId || "");
    setSelectedManager(entry.employeeId || "");
    setSelectedDsaSalesManager(entry.dsaEmployeeId || 0);
    setEntryId(entry.entryId || "");
    setProductType(entry.businessType || "");
    setSelectedAppliedTo(entry.finananceId || "");
    setProviderPayout(mis.grossPayoutPercent || 0);
    setRemarks(mis.remarks || "");
    setSelectedSubDSA(entry.subDsaId || -1);
    setSubDsaPayout(mis.subDSAPayoutPercent || 0);
    setEntryCondition(mis.misstatus || "");
    setSelectedGroup("1");
    setBusinessStatus(entry.businessStatus ?? "");
    setBusinessMonthId(entry.businessMonthId || "");
    setBusinessMonthID(entry.businessMonthId || "");
    setSubDsaTdsPercent(entry.subDsaTdsPercent || 0);
    setDsaTdsPercent(entry.dsaTdsPercent || 0);
    setDisbursedAmount(entry.disbursedAmount || 0);
    setActualDsaPayout(mis.dsapayoutPercent || 0);
    setDSAPayout(mis.dsamargin || 0);
    setServiceTypeCode(entry.businessType || "");
  };
  const handleSave = (e) => {
    e.preventDefault();
    if (!startDate && !frequency && !duration) {
      setAlert("Please fill startDate, frequency, duration'", "error");
      return;
    }
    if (editStatus) {
      putLoanEntryApiCall();
    } else {
      postLoanEntryApiCall();
    }
  };
  const resetFormState = () => {
    handleReset();
    setEditStatus(false);
  };
  function formatTimestampToDate(timestamp) {
    const date = new Date(timestamp); // Convert timestamp to Date object
    return date.toISOString().slice(0, 10); // Format it as "YYYY-MM-DD"
  }
  function openDailogDeleteBox(fEntryId) {
    setOpenDialog(true);
    SetServiceEntryId(fEntryId);
  }
  function handleConfirmDelete() {
    deleteLoanEntryApiCall(serviceEntryId); // Only delete if entryId exists
    setTimeout(() => {
      setOpenDialog(false);
    }, 1000);
  }
  const businessStatusMap = {
    0: "New",
    1: "In Progress",
    2: "MIS Sent",
    3: "Invoice Raised",
    4: "Disbursed",
    21: "Aborted",
  };
  const ActionCellRenderer = (props) => {
    const rowIndex = props.node.rowIndex;
    let rowData = null;

    if (props.api && props.api.getDisplayedRowAtIndex(rowIndex)) {
      rowData = props.api.getDisplayedRowAtIndex(rowIndex).data;
    } else {
      console.error("API or row data is not available.");
    }

    const handleEditClick = () => {
      if (rowData) {
        handleEditLoanRow(rowData);
      }
    };

    const handleDeleteClick = () => {
      if (rowData && rowData.businessEntry.entryId) {
        openDailogDeleteBox(rowData.businessEntry.entryId);
      } else {
        console.warn("Row data or entry ID is not available for deletion.");
      }
    };
    return (
      <div>
        <ViewButton type="button" onClick={handleEditClick}>
          <EditIcon />
        </ViewButton>
        <DeleteButton type="button" onClick={() => handleDeleteClick()}>
          <DeleteIcon />
        </DeleteButton>
      </div>
    );
  };
  const columns = [
    {
      headerName: "Start of Insurance",
      field: "businessEntry.loginDate",
      filter: true,
      sorted: true,
      minWidth: 90,
      valueFormatter: (params) => {
        const rawDate = params.data?.businessEntry?.date;
        if (!rawDate) return "-";
        const date = new Date(rawDate);
        const day = date.getDate().toString().padStart(2, "0");
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
      sort: "desc",
    },
    {
      headerName: "Policy Number",
      field: "businessEntry.applicationNumber",
      filter: true,
      sorted: true,
      minWidth: 70,
      flex: 1,
      valueGetter: (params) => params.data?.businessEntry?.applicationNumber ?? "-",
    },
    {
      headerName: "Customer Name",
      field: "businessEntry.customerName",
      filter: true,
      sorted: true,
      minWidth: 70,
      flex: 2,
      valueGetter: (params) => params.data?.businessEntry?.customerName ?? "-",
    },
    {
      headerName: "Premium Amount",
      field: "businessEntry.appliedAmount",
      filter: true,
      sortable: true,
      minWidth: 100,
      flex: 1.1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
      valueGetter: (params) => params.data?.businessEntry?.appliedAmount ?? 0,
      valueFormatter: (params) =>
        `₹ ${Number(params.value).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
    },
    {
      headerName: "Revenue (%)",
      field: "misData.grossPayoutPercent",
      valueGetter: (params) => params.data?.misData?.grossPayoutPercent ?? "-",
      filter: true,
      sortable: true,
      editable: true,
      flex: 1,
      cellStyle: { textAlign: "right", fontWeight: "500" },
    },
    {
      headerName: "DSA Payout (%)",
      field: "misData.dsapayoutPercent",
      valueGetter: (params) => params.data?.misData?.dsapayoutPercent ?? "-",
      filter: true,
      sortable: true,
      editable: true,
      cellStyle: { textAlign: "right", fontWeight: "500" },
    },
    {
      headerName: "Actions",
      cellRenderer: ActionCellRenderer,
      width: 120,
    },
  ];
  const handleCheckboxChange = (e) => {
    setConnectorFormData({
      ...connectorFormData,
      hasGST: e.target.checked,
      gstNumber: e.target.checked ? connectorFormData.gstNumber : "", // Reset GST if unchecked
    });
  };
  const handleAbortClick = () => {
    if (Number(businessStatus) === 21) {
      setUnAbortBox(true);
      setOpenDailogAbortBox(true);
      return;
    }
    if (entryCondition == "C" || entryCondition == "A") {
      setAlert("The application has sent to headoffice in mis, We cannot abort it", "error");
      return;
    } else {
      setOpenDailogAbortBox(true);
    }
  };
  const handleConfirmAbort = async () => {
    if (Number(businessStatus) === 21) {
      try {
        const url = URLs.resumeEntry;
        const options = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt_token}`,
          },
          body: JSON.stringify([entryId]),
        };

        const response = await fetch(url, options);

        if (response.ok) {
          setAlert("Application Resumed Successfully", "success");
          setActiveTab(0);
        } else {
          setAlert(errorData.message || "failed to Resume Application", "error");
        }
      } catch (error) {
        setAlert("An error occurred while Resume Application", "error");
      } finally {
        setOpenDailogAbortBox(false);
      }
    } else {
      try {
        const url = URLs.abortEntry;
        const options = {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt_token}`,
          },
          body: JSON.stringify([entryId]),
        };

        const response = await fetch(url, options);

        if (response.ok) {
          setAlert("Aborted Successfully", "success");
          setActiveTab(0);
        } else {
          setAlert(errorData.message || "failed to abort", "error");
        }
      } catch (error) {
        setAlert("An error occurred while aborting", "error");
      } finally {
        setOpenDailogAbortBox(false);
      }
    }
  };
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const tabs = [{ label: "Entries" }, { label: "Entry Form" }];
  const handleGstPercentChange = (index, value) => {
    const updated = [...dueDates];
    updated[index].gst = parseFloat(value) || 0; // Convert string to float
    setDueDates(updated);
  };
  const handlePayoutChange = (index, value) => {
    const updated = [...dueDates];
    updated[index].payoutPercent = parseFloat(value) || 0; // Convert string to float
    setDueDates(updated);
  };
  const getPaymentStatusText = (insurancePaid, agentPayoutReceived) => {
    if (insurancePaid === "N") {
      return "Insurance Not Paid";
    } else if (insurancePaid === "Y" && agentPayoutReceived === "Y") {
      return "Insurance Paid - Payout Received";
    } else if (insurancePaid === "Y" && agentPayoutReceived === "N") {
      return "Insurance Paid - Payout Pending";
    } else {
      return "";
    }
  };
  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date)) return "";

    const options = { year: "numeric", month: "short", day: "2-digit" };
    let formattedDate = date.toLocaleDateString("en-GB", options);

    // Remove the comma
    formattedDate = formattedDate.replace(",", "");

    const [day, month, year] = formattedDate.split(" ");
    if (!day || !month || !year) return "";

    const pascalMonth = month.charAt(0).toUpperCase() + month.slice(1).toLowerCase();
    return `${day}-${pascalMonth}-${year}`;
  };

  return (
    <DashboardLayout>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          borderRadius: "12px",
          overflow: "auto",
          flexGrow: 1,
          boxShadow: "none",
          border: "none",
          height: "100%",
          pt: 2,
          backgroundColor: "transparent",
        }}
      >
        <Dialog
          open={loading}
          onClose={() => setLoading(false)}
          aria-labelledby="loading-dialog-title"
        >
          <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <CircularProgress color="primary" />
            <Typography variant="h6" style={{ marginTop: "20px" }}>
              Loading, please wait...
            </Typography>
          </DialogContent>
        </Dialog>
        <Dialog open={openDialog}>
          <DialogContent sx={subDialogContentStyle}>
            <DialogContentText sx={dialogContentTextStyle}>
              {`Are you sure you want to delete`}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={entryStyles.dialogActions}>
            <StyledButton onClick={handleConfirmDelete}>Yes</StyledButton>
            <StyledButton onClick={() => setOpenDialog(false)} variant="outlined">
              No
            </StyledButton>
          </DialogActions>
        </Dialog>
        <Dialog open={openDailogAbortBox}>
          <DialogContent sx={subDialogContentStyle}>
            <DialogContentText sx={dialogContentTextStyle}>
              {unAbortbox
                ? `Are you sure you want to Initiate application number ${applicationNumber} for ${customerName}?`
                : `Are you sure you want to abort application number ${applicationNumber} for ${customerName}?`}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={entryStyles.dialogActions}>
            <StyledButton onClick={handleConfirmAbort}>Yes</StyledButton>
            <StyledButton onClick={() => setOpenDailogAbortBox(false)} variant="outlined">
              No
            </StyledButton>
          </DialogActions>
        </Dialog>
        <StyledSnackbar
          open={open}
          autoHideDuration={5000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          severity={alertType}
        >
          <StyledAlert onClose={handleClose} severity={alertType}>
            {message}
          </StyledAlert>
        </StyledSnackbar>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            backgroundColor: "transparent",
            boxShadow: "none",
            border: "none",
          }}
        >
          <ResponsiveTabs
            tabs={tabs}
            activeTab={activeTab}
            onChange={handleChange}
            labelColor="secondary"
            bgColor="#e0f7fa"
          />
          {activeTab === 0 && (
            <Box
              sx={{
                overflowX: "auto",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                mt: 1,
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1, mr: 1 }}>
                <Grid container spacing={2} pt={0.7} alignItems="center">
                  <Grid item xs={12} sm={4} md={3} lg={2}>
                    <TextField
                      fullWidth
                      type="date"
                      label="From Date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      sx={MInput.b}
                      InputLabelProps={{
                        shrink: true,
                        sx: {
                          color: MInput.a,
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={2}>
                    <TextField
                      fullWidth
                      type="date"
                      label="To Date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      sx={MInput.b}
                      InputLabelProps={{
                        shrink: true,
                        sx: {
                          color: MInput.a,
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3} lg={2}>
                    <StyledButton onClick={handleGetData}>Get Data</StyledButton>
                  </Grid>
                </Grid>
                <FilterSection
                  businessStatusFilter={businessStatusFilter}
                  setBusinessStatusFilter={setBusinessStatusFilter}
                  monthIdData={monthIdData}
                  businessMonthID={businessMonthID}
                  setBusinessMonthID={setBusinessMonthID}
                  serviceTypeCode={serviceTypeCode}
                  setServiceTypeCode={setServiceTypeCode}
                  handleFilter={handleFilter}
                />
              </Box>
              <StyledAgGridContainer
                component={Paper}
                className="ag-theme-alpine"
                sx={{
                  flexGrow: 1,
                  backgroundColor: "transparent",
                  boxShadow: "none",
                  border: "none",
                }}
              >
                <AgGridReact
                  rowData={entryData}
                  columnDefs={columns}
                  pagination
                  paginationPageSize={11}
                />
              </StyledAgGridContainer>
            </Box>
          )}
          {activeTab === 1 && (
            <Grid container spacing={1} sx={{ mt: 1 }}>
              <Grid item xs={12} md={12}>
                <Box
                  sx={{
                    height: "100%",
                    backgroundColor: "#FFFFFF",
                    borderRadius: "15px",
                    padding: 2,
                  }}
                >
                  <div style={{ ...entryStyles.divStyle }}>
                    <StyledTypography>
                      {!editStatus ? "Entry Form" : "Edit Entry Details"}
                    </StyledTypography>
                    {editStatus && (
                      <>
                        <Tooltip title="Reset">
                          <StyledButtonC onClick={resetFormState}>
                            <RestartAltIcon />
                          </StyledButtonC>
                        </Tooltip>
                        <Tooltip title="">
                          <StyledButtonAbort onClick={handleAbortClick}>
                            {Number(businessStatus) === 21 ? "Resume" : "Abort"}
                          </StyledButtonAbort>
                        </Tooltip>
                      </>
                    )}
                  </div>
                  <form onSubmit={handleSave} autoComplete="off">
                    <Box p={{ sm: 1, md: 2 }} pt={{ xs: 3, sm: 2 }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={3} xl={2}>
                          <TextField
                            label="Business Date"
                            type="date"
                            fullWidth
                            required
                            value={date || new Date().toISOString().split("T")[0]} // Set default value to today's date
                            onChange={(e) => setDate(e.target.value)}
                            InputProps={{
                              readOnly: inputStatus,
                            }}
                            sx={MInput.b}
                            InputLabelProps={{
                              shrink: true,
                              sx: {
                                color: MInput.a,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6} xl={2}>
                          <TextField
                            label="Policy Number"
                            fullWidth
                            required
                            value={applicationNumber}
                            onChange={(e) => setApplicationNumber(e.target.value.trim())}
                            InputProps={{ readOnly: inputStatus }}
                            sx={MInput.b}
                            InputLabelProps={{
                              sx: {
                                color: MInput.a,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={4} xl={3}>
                          <TextField
                            label="Customer Name"
                            fullWidth
                            required
                            value={customerName}
                            onChange={(e) => setCustomerName(e.target.value)}
                            InputProps={{ readOnly: inputStatus }}
                            sx={MInput.b}
                            InputLabelProps={{
                              sx: {
                                color: MInput.a,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={4} xl={2}>
                          <TextField
                            label="Premium Amount"
                            fullWidth
                            required
                            value={LoanAmount}
                            onChange={() => {}}
                            InputProps={{
                              readOnly: inputStatus,
                              inputComponent: CurrencyInput,
                              inputProps: {
                                value: LoanAmount,
                                decimalsLimit: 2,
                                prefix: "₹ ",
                                onValueChange: (value) => setLoanAmount(value),
                                intlConfig: { locale: "en-IN" }, // Indian number format
                              },
                            }}
                            sx={MInput.b}
                            InputLabelProps={{
                              sx: {
                                color: MInput.a,
                              },
                            }}
                          />
                        </Grid>
                        <Grid item xs={12} md={6} xl={3}>
                          <Autocomplete
                            options={managersData}
                            getOptionLabel={(option) => option.firstName + " " + option.lastName}
                            value={
                              managersData.some((item) => item.employeeId === selectedManager)
                                ? managersData.find((item) => item.employeeId === selectedManager)
                                : null
                            }
                            onChange={(event, value) =>
                              setSelectedManager(value ? value.employeeId : "")
                            }
                            disableClearable={false}
                            filterOptions={(options, state) => {
                              const input = state.inputValue.toLowerCase();

                              // Separate options into those that start with the input and those that contain itlastName
                              const startsWithInput = options.filter((option) =>
                                (option.firstName + " " + option.lastName)
                                  .toLowerCase()
                                  .startsWith(input)
                              );

                              const containsInput = options.filter(
                                (option) =>
                                  !(option.firstName + " " + option.lastName)
                                    .toLowerCase()
                                    .startsWith(input) &&
                                  (option.firstName + " " + option.lastName)
                                    .toLowerCase()
                                    .includes(input)
                              );

                              // Combine the options with those starting with the input first, then the rest
                              return [...startsWithInput, ...containsInput];
                            }}
                            PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Head Office Manager"
                                variant="outlined"
                                required
                                sx={{
                                  height: 43,
                                  ...MInput.b,
                                  "& .MuiInputBase-root": {
                                    height: "100%",
                                    minHeight: 43,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a, // Ensure this applies to the label
                                    "&.Mui-focused": {
                                      color: "red", // Focused label color
                                    },
                                  },
                                }}
                              />
                            )}
                            disabled={inputStatus}
                          />
                        </Grid>
                        <Grid item xs={12} md={4} xl={2}>
                          <Autocomplete
                            options={insuranceAgents}
                            getOptionLabel={(option) =>
                              `${option.firstName || ""} ${option.lastName || ""}`.trim()
                            }
                            value={
                              insuranceAgents.some((agent) => agent.employeeId === selectedDSA)
                                ? insuranceAgents.find((agent) => agent.employeeId === selectedDSA)
                                : null
                            }
                            onChange={(event, value) =>
                              setSelectedDSA(value ? value.employeeId : "")
                            }
                            disableClearable={false}
                            filterOptions={(options, state) => {
                              const input = state.inputValue.toLowerCase();

                              const startsWithInput = options.filter((option) => {
                                const name = `${option.firstName || ""} ${option.lastName || ""}`
                                  .toLowerCase()
                                  .trim();
                                return name.startsWith(input);
                              });

                              const containsInput = options.filter((option) => {
                                const name = `${option.firstName || ""} ${option.lastName || ""}`
                                  .toLowerCase()
                                  .trim();
                                return !name.startsWith(input) && name.includes(input);
                              });

                              return [...startsWithInput, ...containsInput];
                            }}
                            PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Agent"
                                variant="outlined"
                                required
                                sx={{
                                  height: 43,
                                  ...MInput.b,
                                  "& .MuiInputBase-root": {
                                    height: "100%",
                                    minHeight: 43,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a,
                                    "&.Mui-focused": {
                                      color: "red",
                                    },
                                  },
                                }}
                              />
                            )}
                            disabled={inputStatus}
                          />
                        </Grid>

                        <Grid item xs={12} md={4} xl={2}>
                          <Autocomplete
                            options={subDsaData}
                            getOptionLabel={(option) => option.dsaName}
                            value={
                              subDsaData.some((item) => item.dsaId === selectedSubDSA)
                                ? subDsaData.find((item) => item.dsaId === selectedSubDSA)
                                : null
                            }
                            onChange={(event, value) => setSelectedSubDSA(value ? value.dsaId : -1)}
                            disableClearable={false}
                            filterOptions={(options, state) => {
                              const input = state.inputValue.toLowerCase();
                              // Separate options into those that start with the input and those that contain it
                              const startsWithInput = options.filter((option) =>
                                option.dsaName.toLowerCase().startsWith(input)
                              );
                              const containsInput = options.filter(
                                (option) =>
                                  !option.dsaName.toLowerCase().startsWith(input) &&
                                  option.dsaName.toLowerCase().includes(input)
                              );
                              // Combine the options with those starting with the input first, then the rest
                              return [...startsWithInput, ...containsInput];
                            }}
                            PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Connector"
                                variant="outlined"
                                sx={{
                                  height: 43,
                                  ...MInput.b,
                                  "& .MuiInputBase-root": {
                                    height: "100%",
                                    minHeight: 43,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a, // Ensure this applies to the label
                                    "&.Mui-focused": {
                                      color: "red", // Focused label color
                                    },
                                  },
                                }}
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>
                                      {params.InputProps.endAdornment}
                                      <PersonAddIcon
                                        style={{ cursor: "pointer", marginLeft: 8 }}
                                        onClick={handleOpenPopover}
                                      />
                                    </>
                                  ),
                                }}
                              />
                            )}
                            disabled={inputStatus}
                          />
                          <Popover
                            id={id}
                            open={openC}
                            anchorEl={anchorEl}
                            onClose={handleClosePopover}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                            PaperProps={{
                              sx: {
                                backgroundColor: "#ffffff", // Dark white background
                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Optional shadow for better visibility
                                borderRadius: "8px", // Rounded corners for a modern look
                              },
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                          >
                            <Box sx={{ p: 1, width: "15vw", maxwidth: 250, minWidth: 150 }}>
                              <StyledTypographyA>Add Connector</StyledTypographyA>
                              <TextField
                                name="connectorId"
                                label="Connector ID"
                                value={connectorFormData.connectorId}
                                onChange={handleConnectorChange}
                                fullWidth
                                margin="dense"
                                sx={MInput.b}
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a,
                                  },
                                }}
                              />
                              <TextField
                                name="connectorName"
                                label="Connector Name"
                                value={connectorFormData.connectorName}
                                onChange={handleConnectorChange}
                                fullWidth
                                margin="dense"
                                sx={MInput.b}
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a,
                                  },
                                }}
                              />
                              <TextField
                                name="panNumber"
                                label="PAN Number"
                                value={connectorFormData.panNumber}
                                onChange={handleConnectorChange}
                                fullWidth
                                margin="dense"
                                sx={MInput.b}
                                InputProps={{ inputProps: { maxLength: 10 } }} // PAN is 10 characters
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a,
                                  },
                                }}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={connectorFormData.hasGST}
                                    onChange={handleCheckboxChange}
                                  />
                                }
                                label="Connector has GST"
                              />

                              {/* Conditional GST Number Entry Field */}
                              {connectorFormData.hasGST && (
                                <TextField
                                  name="gstNumber"
                                  label="GST Number"
                                  value={connectorFormData.gstNumber}
                                  onChange={handleConnectorChange}
                                  fullWidth
                                  margin="dense"
                                  sx={MInput.b}
                                  InputProps={{ inputProps: { maxLength: 15 } }} // GST is 15 characters
                                  InputLabelProps={{
                                    sx: {
                                      color: MInput.a,
                                    },
                                  }}
                                />
                              )}

                              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
                                <StyledButtonAnchor
                                  onClick={handleClosePopover}
                                  sx={{
                                    backgroundColor: "#ffffff",
                                    border: `1px solid red`,
                                    color: "red",
                                  }}
                                >
                                  close
                                </StyledButtonAnchor>
                                <StyledButtonAnchor
                                  onClick={handleConnectorSave}
                                  variant="contained"
                                  color="primary"
                                  sx={{ ml: 2 }}
                                  disabled={disbursements.length > 0}
                                >
                                  Save
                                </StyledButtonAnchor>
                              </Box>
                            </Box>
                          </Popover>
                        </Grid>
                        <Grid item xs={12} md={4} xl={2}>
                          <Autocomplete
                            options={businessMasterData}
                            getOptionLabel={(option) => option.businessName}
                            value={
                              businessMasterData.some(
                                (item) => item.businessID === selectedLoanType
                              )
                                ? businessMasterData.find(
                                    (item) => item.businessID === selectedLoanType
                                  )
                                : null
                            }
                            onChange={(event, value) => {
                              setProductType(value ? value.type : "");
                              setSelectedLoanType(value ? value.businessID : "");
                            }}
                            disableClearable={false}
                            filterOptions={(options, state) => {
                              const input = state.inputValue.toLowerCase();
                              // Separate the options into those that start with the input and those that contain it
                              const startsWithInput = options.filter((option) =>
                                option.businessName.toLowerCase().startsWith(input)
                              );
                              const containsInput = options.filter(
                                (option) =>
                                  !option.businessName.toLowerCase().startsWith(input) &&
                                  option.businessName.toLowerCase().includes(input)
                              );
                              // Combine the options with those starting with the input first, then the rest
                              return [...startsWithInput, ...containsInput];
                            }}
                            PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Insurance"
                                variant="outlined"
                                required
                                sx={{
                                  height: 43,
                                  ...MInput.b,
                                  "& .MuiInputBase-root": {
                                    height: "100%",
                                    minHeight: 43,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a, // Ensure this applies to the label
                                    "&.Mui-focused": {
                                      color: "red", // Focused label color
                                    },
                                  },
                                }}
                              />
                            )}
                            disabled={inputStatus}
                          />
                        </Grid>
                        <Grid item xs={12} md={4} xl={2}>
                          <Autocomplete
                            options={finalFinanceData}
                            getOptionLabel={(option) => option.finainacialInstitutionName}
                            value={
                              finalFinanceData.some(
                                (item) => item.finananceId === selectedAppliedTo
                              )
                                ? finalFinanceData.find(
                                    (item) => item.finananceId === selectedAppliedTo
                                  )
                                : null
                            }
                            onChange={(event, value) =>
                              setSelectedAppliedTo(value ? value.finananceId : "")
                            }
                            disableClearable={false}
                            filterOptions={(options, state) => {
                              const input = state.inputValue.toLowerCase();

                              // Filter options that start with the input value
                              const startsWithInput = options.filter((option) =>
                                option.finainacialInstitutionName.toLowerCase().startsWith(input)
                              );

                              // Filter options that contain the input value but do not start with it
                              const containsInput = options.filter(
                                (option) =>
                                  !option.finainacialInstitutionName
                                    .toLowerCase()
                                    .startsWith(input) &&
                                  option.finainacialInstitutionName.toLowerCase().includes(input)
                              );

                              // Combine the options: ones that start with the input first, then the rest
                              return [...startsWithInput, ...containsInput];
                            }}
                            PaperComponent={CustomPaper}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Provider Name"
                                variant="outlined"
                                required
                                sx={{
                                  height: 43,
                                  ...MInput.b,
                                  "& .MuiInputBase-root": {
                                    height: "100%",
                                    minHeight: 43,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: MInput.a, // Ensure this applies to the label
                                    "&.Mui-focused": {
                                      color: "red", // Focused label color
                                    },
                                  },
                                }}
                              />
                            )}
                            disabled={inputStatus}
                          />
                        </Grid>
                        <Grid item xs={12} md={3} xl={2}>
                          <TextField
                            label="Provider Payout %"
                            type="number" // Use "text" to handle custom validation for the format
                            fullWidth
                            required
                            value={providerPayout}
                            onChange={(e) => {
                              const value = e.target.value;
                              // Regex to match the format X.yyyy where X < 9 and yyyy can be 1-3 digits
                              if (/^\d{0,2}(\.\d{0,3})?$/.test(value)) {
                                setProviderPayout(value);
                              }
                            }}
                            inputProps={{
                              maxLength: 5,
                              readOnly: inputStatus,
                            }} // Limit the total length to 5 characters
                            placeholder="0.000" // Example format
                            sx={MInput.b}
                            InputLabelProps={{
                              sx: {
                                color: MInput.a,
                              },
                            }}
                          />
                        </Grid>
                        {selectedSubDSA > -1 && (
                          <Grid item xs={12} md={3} xl={2}>
                            <TextField
                              label="Connector % in Provider Payout"
                              type="text" // Use "text" to handle custom validation for the format
                              fullWidth
                              required
                              value={subDsaPayout}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d{0,3}(\.\d{0,3})?$/.test(value)) {
                                  setSubDsaPayout(value);
                                }
                              }}
                              inputProps={{
                                maxLength: 5,
                                readOnly: inputStatus,
                              }}
                              placeholder="0.000" // Example format
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                  paddingBottom: "5px",
                                },
                              }}
                            />
                          </Grid>
                        )}
                        <Grid item xs={12} md={12} xl={10}>
                          <TextField
                            label="Remarks"
                            fullWidth
                            multiline
                            rows={2}
                            value={remarks}
                            onChange={(e) => setRemarks(e.target.value)}
                            sx={MInput.b}
                            InputLabelProps={{
                              sx: {
                                color: MInput.a,
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                      <Grid item xs={12} md={12}>
                        <Box
                          sx={{
                            height: "100%",
                            padding: 0,
                          }}
                        >
                          <TableContainer
                            component={Paper}
                            sx={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              overflowX: "auto",
                              padding: 0,
                              margin: 0,
                              position: "relative",
                              "&:hover": {
                                "& ::-webkit-scrollbar": {
                                  width: "6px",
                                  height: "6px",
                                  transition: "width 0.3s ease, height 0.3s ease",
                                },
                                "& ::-webkit-scrollbar-thumb": {
                                  backgroundColor: "rgba(49, 64, 111, 0.7)", // Visible thumb on hover
                                  borderRadius: "4px",
                                },
                                "& ::-webkit-scrollbar-track": {
                                  backgroundColor: "#e0e0e0",
                                },
                              },
                              scrollbarWidth: "thin",
                            }}
                          >
                            {renewalTab === 0 && (
                              <Grid container sx={{ width: "100%" }}>
                                <Grid item xs={12}>
                                  <Card elevation={4} sx={{ p: 0, pt: 2, height: "100%" }}>
                                    <CardContent>
                                      {renewalTab === 0 && (
                                        <Box>
                                          <Typography variant="h6" gutterBottom>
                                            Policy Renewal Details
                                          </Typography>

                                          <Grid container spacing={2}>
                                            <Grid item xs={12} md={6} lg={2}>
                                              <TextField
                                                type="date"
                                                label="Policy Start Date"
                                                value={loginDate}
                                                onChange={(e) => {
                                                  setLoginDate(e.target.value);
                                                  setStartDate(e.target.value);
                                                }}
                                                fullWidth
                                                sx={MInput.b}
                                                InputLabelProps={{
                                                  shrink: true,
                                                  sx: {
                                                    color: MInput.a,
                                                  },
                                                }}
                                              />
                                            </Grid>

                                            <Grid item xs={12} md={6} lg={2}>
                                              <TextField
                                                type="number"
                                                label="Policy Duration (in years)"
                                                value={duration}
                                                onChange={(e) => setDuration(e.target.value)}
                                                fullWidth
                                                sx={MInput.b}
                                                InputLabelProps={{
                                                  sx: {
                                                    color: MInput.a,
                                                  },
                                                }}
                                              />
                                            </Grid>
                                            <Grid item xs={12} md={6} lg={2}>
                                              <Autocomplete
                                                options={frequencyOptions}
                                                value={frequency}
                                                onChange={(event, newValue) =>
                                                  setFrequency(newValue)
                                                }
                                                fullWidth
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    label="Payment Frequency"
                                                    fullWidth
                                                    sx={{
                                                      height: 43,
                                                      ...MInput.b,
                                                      "& .MuiInputBase-root": {
                                                        height: "100%",
                                                        minHeight: 43,
                                                      },
                                                    }}
                                                    InputLabelProps={{
                                                      sx: {
                                                        color: MInput.a, // Ensure this applies to the label
                                                        "&.Mui-focused": {
                                                          color: "red", // Focused label color
                                                        },
                                                      },
                                                    }}
                                                  />
                                                )}
                                              />
                                            </Grid>
                                            <Grid item xs={12} md={6} lg={2}>
                                              <StyledButton type="button" onClick={handleGenerate}>
                                                Generate Due Dates
                                              </StyledButton>
                                            </Grid>
                                            <Grid item xs={12}>
                                              <Box mt={2}>
                                                <Typography
                                                  variant="h6"
                                                  gutterBottom
                                                  sx={{ fontWeight: "normal" }}
                                                >
                                                  Policy End Date:{" "}
                                                  <strong>{formatDate(endDate)}</strong>
                                                </Typography>

                                                <Box mt={2}>
                                                  <Typography variant="h6" gutterBottom>
                                                    All Premium Due Dates:
                                                  </Typography>
                                                  <TableContainer
                                                    component={Paper}
                                                    sx={{
                                                      overflowY: "auto",
                                                      width: "100%",
                                                      "&::-webkit-scrollbar": {
                                                        width: "5px",
                                                      },
                                                      "&::-webkit-scrollbar-thumb": {
                                                        backgroundColor: "rgba(0, 0, 0, 0.3)",
                                                        borderRadius: "5px",
                                                        minHeight: "40px", // Minimum height of the thumb
                                                        marginTop: "auto", // Helps push it to the bottom when short content
                                                      },
                                                      "&::-webkit-scrollbar-track": {
                                                        backgroundColor: "transparent",
                                                        marginTop: "auto", // Attempt to mimic bottom-aligned scrollbar
                                                      },
                                                      scrollbarWidth: "thin",
                                                    }}
                                                  >
                                                    <Table size="small">
                                                      <TableBody>
                                                        <TableRow
                                                          sx={{
                                                            position: "sticky",
                                                            top: 0,
                                                            backgroundColor: "orange",
                                                            zIndex: 10,
                                                          }}
                                                        >
                                                          <TableCell sx={{ fontWeight: "bold" }}>
                                                            Status
                                                          </TableCell>
                                                          <TableCell sx={{ fontWeight: "bold" }}>
                                                            Date
                                                          </TableCell>
                                                          <TableCell sx={{ fontWeight: "bold" }}>
                                                            Payout %
                                                          </TableCell>
                                                          <TableCell
                                                            align="right"
                                                            sx={{ fontWeight: "bold" }}
                                                          >
                                                            Payout
                                                          </TableCell>
                                                          <TableCell sx={{ fontWeight: "bold" }}>
                                                            GST %
                                                          </TableCell>
                                                          <TableCell
                                                            align="right"
                                                            sx={{ fontWeight: "bold" }}
                                                          >
                                                            Premium (Incl. GST)
                                                          </TableCell>
                                                          <TableCell sx={{ fontWeight: "bold" }}>
                                                            Remarks
                                                          </TableCell>
                                                        </TableRow>
                                                        {dueDates.map((item, index) => (
                                                          <TableRow key={index}>
                                                            <TableCell
                                                              sx={{
                                                                fontSize: "14px",
                                                                fontWeight: 500,
                                                              }}
                                                            >
                                                              <Box
                                                                sx={{
                                                                  display: "inline-block",
                                                                  padding: "6px 14px",
                                                                  borderRadius: "999px", // Fully rounded pill
                                                                  fontSize: "15px",
                                                                  fontWeight: 700,
                                                                  color:
                                                                    item.paidStatus === "N" ||
                                                                    item.paidStatus === null ||
                                                                    item.paidStatus === undefined
                                                                      ? "#D32F2F" // Soft red text
                                                                      : item.paidStatus === "Y" &&
                                                                        item.payoutStatus === "Y"
                                                                      ? "#8E24AA" // Violet text for "Insurance Paid - Payout Received"
                                                                      : item.paidStatus === "Y" &&
                                                                        item.payoutStatus === "N"
                                                                      ? "#F57C00" // Soft orange text
                                                                      : "#333", // Default gray text
                                                                  backgroundColor:
                                                                    item.paidStatus === "N" ||
                                                                    item.paidStatus === null ||
                                                                    item.paidStatus === undefined
                                                                      ? "#FFEBEE" // Light red bg
                                                                      : item.paidStatus === "Y" &&
                                                                        item.payoutStatus === "Y"
                                                                      ? "#F3E5F5" // Light violet bg for "Insurance Paid - Payout Received"
                                                                      : item.paidStatus === "Y" &&
                                                                        item.payoutStatus === "N"
                                                                      ? "#FFF3E0" // Light orange bg
                                                                      : "#F5F5F5", // Light gray for default
                                                                  border: "1px solid",
                                                                  borderColor:
                                                                    item.paidStatus === "N" ||
                                                                    item.paidStatus === null ||
                                                                    item.paidStatus === undefined
                                                                      ? "#FFCDD2" // Light red border
                                                                      : item.paidStatus === "Y" &&
                                                                        item.payoutStatus === "Y"
                                                                      ? "#E1BEE7" // Light violet border
                                                                      : item.paidStatus === "Y" &&
                                                                        item.payoutStatus === "N"
                                                                      ? "#FFE0B2" // Light orange border
                                                                      : "#E0E0E0", // Light gray border
                                                                  transition: "all 0.3s ease", // Smooth transition for hover effect
                                                                  "&:hover": {
                                                                    transform: "scale(1.05)", // Slightly scale up on hover for interactive feel
                                                                    boxShadow:
                                                                      "0px 4px 8px rgba(0, 0, 0, 0.1)", // Add a light shadow on hover
                                                                  },
                                                                }}
                                                              >
                                                                {getPaymentStatusText(
                                                                  item.paidStatus,
                                                                  item.payoutStatus
                                                                )}
                                                              </Box>
                                                            </TableCell>

                                                            <TableCell
                                                              sx={{
                                                                fontSize: "14px",
                                                                fontWeight: 500,
                                                              }}
                                                            >
                                                              {formatDate(item.scheduleDate)}
                                                            </TableCell>

                                                            <TableCell>
                                                              <TextField
                                                                label="Payout %"
                                                                type="number" // Use number, but control format manually
                                                                fullWidth
                                                                required
                                                                value={item.payoutPercent}
                                                                onChange={(e) => {
                                                                  const value = e.target.value;
                                                                  // Regex: Up to 2 digits before dot, up to 3 digits after dot
                                                                  if (
                                                                    /^\d{0,2}(\.\d{0,3})?$/.test(
                                                                      value
                                                                    )
                                                                  ) {
                                                                    handlePayoutChange(
                                                                      index,
                                                                      value
                                                                    );
                                                                  }
                                                                }}
                                                                inputProps={{
                                                                  maxLength: 5, // Limit total length to 5 characters
                                                                }}
                                                                placeholder="0.000"
                                                                sx={{ width: 100 }}
                                                              />
                                                            </TableCell>

                                                            <TableCell
                                                              align="right"
                                                              sx={{
                                                                fontWeight: 700,
                                                              }}
                                                            >
                                                              {LoanAmount != null &&
                                                              item?.payoutPercent != null
                                                                ? "₹ " +
                                                                  (
                                                                    Number(LoanAmount) *
                                                                    (Number(item.payoutPercent) /
                                                                      100)
                                                                  ).toLocaleString("en-IN", {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2,
                                                                  })
                                                                : "0.00"}
                                                            </TableCell>
                                                            <TableCell>
                                                              <TextField
                                                                label="GST %"
                                                                type="number" // Use number, but control format manually
                                                                fullWidth
                                                                required
                                                                value={item.gst}
                                                                onChange={(e) => {
                                                                  const value = e.target.value;
                                                                  // Regex: Up to 2 digits before dot, up to 3 digits after dot
                                                                  if (
                                                                    /^\d{0,2}(\.\d{0,3})?$/.test(
                                                                      value
                                                                    )
                                                                  ) {
                                                                    handleGstPercentChange(
                                                                      index,
                                                                      value
                                                                    );
                                                                  }
                                                                }}
                                                                inputProps={{
                                                                  maxLength: 5, // Limit total length to 5 characters
                                                                }}
                                                                placeholder="0.000"
                                                                sx={{ width: 100 }}
                                                              />
                                                            </TableCell>
                                                            <TableCell
                                                              align="right"
                                                              sx={{
                                                                fontWeight: 700,
                                                              }}
                                                            >
                                                              {LoanAmount != null &&
                                                              item?.gst != null
                                                                ? "₹ " +
                                                                  (
                                                                    Number(LoanAmount) +
                                                                    Number(LoanAmount) *
                                                                      (Number(item.gst) / 100)
                                                                  ).toLocaleString("en-IN", {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2,
                                                                  })
                                                                : "0.00"}
                                                            </TableCell>

                                                            <TableCell>
                                                              <Typography
                                                                variant="body2"
                                                                sx={{
                                                                  fontSize: "14px",
                                                                  fontWeight: 500,
                                                                }}
                                                              >
                                                                {item.remarks}
                                                              </Typography>
                                                            </TableCell>
                                                          </TableRow>
                                                        ))}
                                                      </TableBody>
                                                    </Table>
                                                  </TableContainer>
                                                </Box>
                                              </Box>
                                            </Grid>
                                          </Grid>
                                        </Box>
                                      )}
                                    </CardContent>
                                  </Card>
                                </Grid>
                              </Grid>
                            )}
                          </TableContainer>
                        </Box>
                      </Grid>
                      <MDBox mt={3} mb={0} gap={1} display="flex" justifyContent="flex-end">
                        <StyledButton type="submit">Save</StyledButton>
                      </MDBox>
                    </Box>
                  </form>
                </Box>
              </Grid>
            </Grid>
          )}
        </Box>
      </Box>
    </DashboardLayout>
  );
}
InsuranceEntry.propTypes = {
  data: PropTypes.object.isRequired,
  node: PropTypes.shape({
    rowIndex: PropTypes.number.isRequired,
  }).isRequired,
  uuid: PropTypes.string.isRequired, // Add uuid to propTypes
  api: PropTypes.shape({
    getDisplayedRowAtIndex: PropTypes.func.isRequired,
  }).isRequired,
};
